<template>
	<div class="not-found-container">
		<img src="../assets/images/header.png" alt="Background Image" class="header-image" />

		<div class="container">
			<div class="not-found-content">
				<h2 class="not-found-title">Page Not Found</h2>
				<p class="not-found-message">
					Sorry, we couldn't find the page you're looking for.
				</p>

				<div class="not-found-actions">
					<p class="contact-info">
						If you believe this is an error, please contact the wedding couple for assistance.
					</p>
				</div>
			</div>
		</div>

		<img src="../assets/images/header.png" alt="Background Image" class="header-image bottom" />
	</div>
</template>

<script>
import { useIsMobile } from '@/lib/useIsMobile';

export default {
	name: "NotFoundView",

	setup() {
		const { isMobile } = useIsMobile()
		return { isMobile };
	},
}
</script>

<style scoped>
.not-found-container {
	min-height: 100vh;
	display: flex;
	flex-direction: column;
	background-color: #FFFFFF;
}

.header-image {
	display: block;
	width: 100%;
	max-width: 1449px;
	height: 184px;
	object-fit: cover;
	object-position: center;
	margin: 0 auto;
}

.bottom {
	transform: rotate(180deg);
	margin-top: auto;
}

.container {
	flex: 1;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 2rem;
	text-align: center;
	max-width: 800px;
	margin: 0 auto;
}

.main-title {
	font-family: "Dancing Script", serif;
	font-size: 3rem;
	font-weight: 700;
	color: #01470f;
	margin-bottom: 3rem;
	line-height: 1.2;
}

.not-found-content {
	background-color: #fafafa;
	padding: 3rem 2rem;
	border-radius: 12px;
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
	border: 2px solid #e8f5e8;
	max-width: 600px;
	width: 100%;
}

.not-found-title {
	font-family: "Playfair", serif;
	font-size: 2.5rem;
	font-weight: 600;
	color: #01470f;
	margin-bottom: 1.5rem;
}

.not-found-message {
	font-family: "Playfair", serif;
	font-size: 1.1rem;
	color: #36454F;
	line-height: 1.6;
	margin-bottom: 2rem;
}

.not-found-actions {
	border-top: 1px solid #e0e0e0;
	padding-top: 1.5rem;
}

.contact-info {
	font-family: "Playfair", serif;
	font-size: 1rem;
	color: #666;
	font-style: italic;
}

/* Mobile responsive */
@media (max-width: 768px) {
	.main-title {
		font-size: 2.5rem;
		margin-bottom: 2rem;
	}

	.not-found-title {
		font-size: 2rem;
	}

	.not-found-content {
		padding: 2rem 1.5rem;
		margin: 0 1rem;
	}

	.not-found-message {
		font-size: 1rem;
	}

	.container {
		padding: 1rem;
	}
}
</style>
